import {Trans} from 'react-i18next'
import React, {Component} from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import {withStyles} from '@material-ui/core/styles'
import messages from '../../../../assets/messages'
import LoadingButton from '../../../Common/LoadingButton'
import FormHelperText from '@material-ui/core/FormHelperText'
import AppContext from '../../../Common/contexts/AppContext'

const styles = theme => ({
  backButton: {
    backgroundColor: theme.palette.background.default
  },
  button:{
    marginTop:0
  },
  errorMessage: {
    color: theme.palette.error.main,
    display: 'inline-block',
    verticalAlign: 'bottom',
    margin: '13px 13px 13px 0'
  },
})

export class DueDiligenceButtonsToolbar extends Component {
  static contextType = AppContext
  render() {
    const {activeStep, previousStep, nextStep, submitForm, classes, submitButtonFeatures:{submitLoading,status}, disableSubmit} = this.props
    return (
      <Grid container spacing={2}>
        {activeStep > 0 &&
        <Grid item>
          <Button color="secondary" variant="contained" size="large" onClick={previousStep}>
            <Trans {...messages.back} />
          </Button>
        </Grid>}
        {activeStep < 1 &&
        <Grid item>
          <Button color="primary" size="large" variant="contained" onClick={nextStep}>
            <Trans {...messages.continue} />
          </Button>
        </Grid>}
        {activeStep === 1 &&
        <Grid item>
          <LoadingButton
            id='loadingButton'
            onClick={submitForm}
            disabled={submitLoading || status==='failure' || disableSubmit}
            hideProgressBar={(!submitLoading && status==='failure') || disableSubmit}
            status={status}
            className={classes.button}
          ><Trans {...messages.submit} />
          </LoadingButton>
          {status==='failure' &&
            <FormHelperText className={classes.errorMessage}><Trans {...messages.generalError} /></FormHelperText>}
        </Grid>}
      </Grid>
    )
  }
}

export default withStyles(styles, {withTheme: true})(DueDiligenceButtonsToolbar)
